import React from "react";

const OrderedList: React.FC<{
  children?: React.ReactNode;
  type?: "decimal" | "lower-alpha" | "upper-alpha" | "lower-roman" | "upper-roman"
}> = ({ children, type = "decimal" }) => {
  return (
    <ol className={type}>
      {React.Children.map(children, (child, index) => (
        <li key={index}>
          {child}
        </li>
      ))}
    </ol>
  );
};

export default OrderedList;